<template>
  <div
    v-if="[STATE.LAUNCH, STATE.TRIAL].includes(currentState)"
    class="trial-button"
  >
    <template v-if="currentState === STATE.LAUNCH">
      <a
        v-if="/^http(s?):\/\//i.test(btnData.url)"
        class="page-ghost-button"
        :href="resolveExternalURL(btnData.url)"
        target="_blank"
      >
        {{ btnText }}
      </a>
      <router-link
        v-else
        class="page-ghost-button"
        :to="{ path: resolveInternalPath(btnData.url) }"
        active-class=""
        exact-active-class=""
      >
        {{ btnText }}
      </router-link>
    </template>
    <div
      v-else
      class="page-ghost-button"
      :class="{ 'is-disabled': currentState === STATE.NOT_FOUND }"
      @click="handleTrialBtnClick"
    >
      {{ btnText }}
    </div>
    <iw-dialog
      :title="$t('applyFormProduct' /* 申请试用产品 */)"
      :visible.sync="isApplyConfirmDialogVisible"
      width="480px"
    >
      <!-- <div>确定申请试用【{{ btnData.productName }}】吗？</div> -->
      <div>{{ $t('applyFormComfirm', { product: btnData.productName } /* 确定申请试用【 xx 】吗？*/) }}</div>
      <div slot="footer">
        <iw-button @click="isApplyConfirmDialogVisible = false">{{ $t('common.cancel' /* 取消 */) }}</iw-button>
        <iw-button type="primary" @click="handleApplyTrial">{{ $t('common.confirm' /* 确定 */) }}</iw-button>
      </div>
    </iw-dialog>
  </div>
</template>

<script>
import { cloneDeep, isEmpty } from "lodash";
import { mapGetters, mapState } from "vuex";
import { tryApply } from "@/api/apps";
const STATE = {
  NOT_FOUND: 0, // 所有产品列表均未找到
  TRIAL: 1, // 只在所有产品列表找到
  LAUNCH: 2 // 在授权产品列表中找到
};
export default {
  name: "TrialButton",
  inject: ["getPageData", "activeApplyTrial"],
  props: {
    productName: String
  },
  data() {
    return {
      STATE,
      currentState: STATE.NOT_FOUND,
      btnData: null,
      isApplyConfirmDialogVisible: false
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
    ...mapGetters(["user"]),
    btnText() {
      let result = this.$t('home.Comingsoon' /* 即将上线，敬请期待 */);
      switch (this.currentState) {
        case STATE.LAUNCH:
          result = this.$t('home.Enter' /* 进入产品 */);
          break;
        case STATE.TRIAL:
          result = this.$t('home.Applyfortrial' /* 申请试用 */);
          break;
      }
      return result;
    }
  },
  mounted() {
    this.initProductsData();
  },
  methods: {
    resolveInternalPath(path) {
      // 内部链接去掉端口号
      return path.trim().replace(/:\d+$/, "");
    },
    resolveExternalURL(url) {
      // 外部链接拼接 token 进行鉴权
      const token = this.$store.state.user.token;
      const joint = url.indexOf("?") > -1 ? "&" : "?";
      return `${url.trim()}${joint}token=${token}`;
    },
    initProductsData() {
      const findTargetProduct = (list = [], target) => {
        let found = null;
        for (const item of list) {
          if (found !== null) break;
          if (Array.isArray(item.children) && item.children.length) {
            if ((found = findTargetProduct(item.children, target)) !== null) {
              break;
            }
          } else {
            for (const _item of item.productList || []) {
              // productName 匹配目标值，且 status 为 1
              if ((_item.productName === target || _item.productName_zh_CN === target) && _item.status === 1) {
                found = _item;
                break;
              }
            }
          }
        }
        return found;
      };
      const pageData = this.getPageData();
      if (pageData.commonData.productsData && pageData.authProducts) {
        // 获取目标产品名，若 props 没有指定产品名，则取当前页面的名字做产品名
        const productName = this.productName || pageData.pageName;
        // 查找目标产品数据并更新指定的按钮状态
        if (
          (this.btnData = cloneDeep(
            findTargetProduct(pageData.authProducts, productName)
          )) !== null
        ) {
          this.currentState = STATE.LAUNCH;
        } else if (
          (this.btnData = cloneDeep(
            findTargetProduct(pageData.commonData.productsData, productName)
          )) !== null
        ) {
          this.currentState = STATE.TRIAL;
        } else {
          this.currentState = STATE.NOT_FOUND;
        }
      }
    },
    handleTrialBtnClick() {
      if (isEmpty(this.user)) {
        this.activeApplyTrial();
      } else {
        this.isApplyConfirmDialogVisible = true;
      }
    },
    handleApplyTrial() {
      if (isEmpty(this.user)) return;
      const { compNm, emalAd, phonNo, userNm } = this.userInfo;
      const { productId, productName } = this.btnData;
      const loading = this.$loading({
        lock: true,
        target: this.$el
      });
      tryApply({
        compNm,
        emalAd,
        phonNo,
        userNm,
        randomCode: "",
        productList: [
          {
            productId,
            productName
          }
        ]
      })
        .then(response => {
          const { status } = response.data || {};
          loading.close();
          this.$message({
            type: status.status === 0 ? "success" : "error",
            message: status.status === 0 ? this.$t('home.Applicationsuccessful' /* 申请成功 */) : this.$t('home.Unsuccessful' /* 申请失败 */),
            customClass:
              status.status === 0 ? "message-success" : "message-error"
          });
          if (status.status === 0) {
            this.isApplyConfirmDialogVisible = false;
          }
        })
        .catch(() => {
          loading.close();
          this.$message({
            type: "error",
            message: this.$t('home.Unsuccessful' /* 申请失败 */),
            customClass: "message-error"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/common";
.trial-button {
  .page-ghost-button {
    height: 48px;
    padding: 0 32px;
    background-color: $color-blue;
    color: #fff;
    font-size: 16px;
    border-color: $color-blue;
    &:hover {
      background-color: darken($color-blue, 6%);
    }
    &:active {
      background-color: darken($color-blue, 10%);
    }
    &.is-disabled {
      background-color: rgba($color-blue, 0.6);
      pointer-events: none;
    }
  }
}
.try-button {
  .page-ghost-button {
    height: 40px;
    width: 220px;
  }
}
</style>
